<!-- Outer container -->
<div class="grade-breakdown-card">

  <!-- Header with toggle -->
  <div class="grade-breakdown-header" (click)="toggleExpanded()">
    <div class="header-content">
      <div class="left-section">
        <svg
          class="chart-icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 21H6.2C5.07989 21 4.51984 21 4.09202 20.782C3.71569 20.5903 3.40973 20.2843 3.21799 19.908C3 19.4802 3 18.9201 3 17.8V3M7 10.5V17.5M11.5 5.5V17.5M16 10.5V17.5M20.5 5.5V17.5"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <div class="title-container">
          <span class="title-text">Overall Grade Component Breakdown</span>
        </div>
      </div>
      <svg
        class="arrow-icon"
        [class.expanded]="isExpanded"
        width="31"
        height="32"
        viewBox="0 0 31 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.996 18.0442L21.5861 11.4541L23.4686 13.3366L14.996 21.8092L6.52344 13.3366L8.40594 11.4541L14.996 18.0442Z"
          fill="white"
        />
      </svg>
    </div>
  </div>

  <!-- Smooth collapsible chart wrapper -->
  <div
    class="breakdown-content-wrapper"
    [class.expanded]="isExpanded"
  >
    <app-grade-breakdown-content [isNewPage]="isNewPage"   [isFullScreen]="isFullScreen"
></app-grade-breakdown-content>
  </div>


</div>

<div class="grade-breakdown-actions">
  <button class="download-btn" (click)="downloadPDF()">Download PDF</button>

  <div class="export-dropdown" (click)="toggleDropdown()" [class.open]="dropdownOpen">
    <button class="export-btn">
      Export Data <span class="dropdown-icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
      <path d="M10.3963 11.8492L14.7455 7.5L15.9879 8.74238L10.3963 14.334L4.80469 8.74238L6.04707 7.5L10.3963 11.8492Z" fill="white"/>
    </svg>
  </span>
    </button>
    <ul class="dropdown-menu" *ngIf="dropdownOpen">
      <li (click)="exportCSV()">Export as CSV</li>
      <li (click)="exportExcel()">Export as Excel</li>
    </ul>
  </div>
</div>
